import { Grid } from "@mui/material";
import style from "../../utils/style";
import PageHeading from "../../components/PageHeading";

function AboutUs() {
	return (
		<Grid container sx={style.container}>
			<Grid item xs={12}>
				<PageHeading text="Privacy Policy" />
				<p>
					At Minibooks, we value your privacy and are committed to
					protecting your personal information. This Privacy Policy
					outlines how we collect, use, and safeguard the data you
					provide when using our mobile application.
				</p>
				<h4>Information We Collect</h4>
				When you create an account or use our mobile application, we may
				collect the following types of personal information:
				<ul>
					<li>
						Contact Information: Your name, email address, and phone
						number.
					</li>
					<li>
						Account Details: Username, password, and security
						questions.
					</li>
					<li>
						Financial Information: Debit/credit card details and
						bank account information.
					</li>
					<li>
						Transaction Details: Details of your purchases, sales,
						and other financial transactions.
					</li>
				</ul>
				<h3>Use of Collected Information</h3>
				<b>
					At Minibooks, we make sure the your valueable data is not
					shared with anyone in anyway
				</b>
				<h3>Data Protection and Security</h3>
				We implement industry-standard security measures to protect your
				personal information from unauthorized access, alteration,
				disclosure, or destruction. These measures include encryption,
				secure storage, and restricted access to your data.
				<h3>Your Rights</h3>
				You have the right to:
				<ul>
					<li>
						Access and Update Your Information: You can access and
						update your personal information through your account
						settings.
					</li>
					<li>
						Data Portability: You can request a copy of your
						personal information in a structured, commonly used, and
						machine-readable format.
					</li>
					<li>
						Withdraw Consent: You can withdraw your consent to the
						processing of your personal information at any time.
					</li>
					<li>
						Erasure: You can request the deletion of your personal
						information, subject to legal obligations and legitimate
						interests.
					</li>
				</ul>
				<h3> Updates to Privacy Policy</h3>
				We may update this Privacy Policy from time to time. Any changes
				will be posted on this page, and we encourage you to review the
				policy periodically. If you have any questions or concerns
				regarding this Privacy Policy, please contact us at{" "}
				<strong>
					<a href="Tel:03287877378">0328-7877378</a>.
				</strong>
				<h4>
					By using Minibooks, you signify your acceptance of this
					Privacy Policy.
				</h4>
			</Grid>
		</Grid>
	);
}

export default AboutUs;
